module.exports = __webpack_public_path__ + "static/media/street4.0f00d21b.jpg";